import {
  ADMIN_TENANT_PAGE_REQUEST,
  ADMIN_TENANT_PAGE_SUCCESS,
  ADMIN_TENANT_PAGE_FAILURE,
  ADMIN_TENANT_PAGE_SAVE_STARTED,
  ADMIN_TENANT_PAGE_SETTING_SAVED,
  ADMIN_TENANT_PAGE_REREAD_SUCCESS,
  ADMIN_TENANT_PAGE_REREAD_FAILURE,
  ADMIN_TENANT_PAGE_NOTICE_DISMISSED
} from '../actions/adminToolsActions';
import {ADMIN_TENANTS_TEST_TENANT_SAVED} from '../actions/adminTenantsActions';

const initialState = {
  tenantId: null,
  status: 'idle',
  error: null,
  settings: null,
  show: null,
  loadedAt: null,
  requestId: 0,
  lastSideEffects: null
};

const mergeShow = (show, patch) => {
  if (!show || !show.tenant) return show;
  const basicinfo = {...show.tenant.basicinfo, ...patch.basicinfo};
  if (patch.basicinfo && patch.basicinfo.price) {
    basicinfo.price = {
      ...(show.tenant.basicinfo && show.tenant.basicinfo.price),
      ...patch.basicinfo.price
    };
  }
  return {...show, tenant: {...show.tenant, basicinfo}};
};

const adminTenantPageReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADMIN_TENANT_PAGE_REQUEST: {
      const sameTenant = state.tenantId === action.tenantId;
      return {
        ...state,
        tenantId: action.tenantId,
        status: 'pending',
        error: null,
        requestId: action.requestId,
        settings: sameTenant ? state.settings : null,
        show: sameTenant ? state.show : null,
        loadedAt: sameTenant ? state.loadedAt : null,
        lastSideEffects: null
      };
    }

    case ADMIN_TENANT_PAGE_SUCCESS:
      if (action.requestId !== state.requestId) return state;
      return {
        ...state,
        tenantId: action.tenantId,
        status: 'succeeded',
        error: null,
        settings: action.settings,
        show: action.show,
        loadedAt: action.loadedAt
      };

    case ADMIN_TENANT_PAGE_FAILURE:
      if (action.requestId !== state.requestId) return state;
      return {...state, status: 'failed', error: action.error};

    case ADMIN_TENANT_PAGE_SAVE_STARTED:
      if (action.tenantId !== state.tenantId) return state;
      return {...state, lastSideEffects: null};

    case ADMIN_TENANT_PAGE_SETTING_SAVED: {
      if (action.tenantId !== state.tenantId || !state.settings) return state;
      const settings = {...state.settings};
      Object.keys(action.patch).forEach(section => {
        // List sections (stores) arrive whole; spreading one into an object would turn it into a keyed object.
        settings[section] = Array.isArray(action.patch[section])
          ? action.patch[section]
          : {...settings[section], ...action.patch[section]};
      });
      const show = action.showPatch
        ? mergeShow(state.show, action.showPatch)
        : state.show;
      return {
        ...state,
        settings,
        show,
        lastSideEffects:
          action.sideEffects.length > 0
            ? {key: action.settingKey, effects: action.sideEffects}
            : null
      };
    }

    case ADMIN_TENANT_PAGE_REREAD_SUCCESS:
      if (action.tenantId !== state.tenantId || !state.settings) return state;
      return {
        ...state,
        status: 'succeeded',
        error: null,
        settings: action.settings,
        show: action.show || state.show
      };

    case ADMIN_TENANT_PAGE_REREAD_FAILURE:
      if (action.tenantId !== state.tenantId || !state.settings) return state;
      return {...state, status: 'failed', error: action.error};

    case ADMIN_TENANTS_TEST_TENANT_SAVED:
      if (action.tenantId !== state.tenantId || !state.settings) return state;
      return {
        ...state,
        settings: {
          ...state.settings,
          tenant_settings: {
            ...state.settings.tenant_settings,
            test_tenant_toggle: action.value
          }
        }
      };

    case ADMIN_TENANT_PAGE_NOTICE_DISMISSED:
      return {...state, lastSideEffects: null};

    default:
      return state;
  }
};

export default adminTenantPageReducer;
